import { useEffect, useState, memo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";

import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import LabelOutlinedIcon from "@mui/icons-material/LabelOutlined";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import {
  useGetLabelsQuery,
  useUpdateLabelMutation,
  useDeleteLabelMutation,
} from "./labelsApiSlice";
import { useGetNotesQuery } from "../notes/notesApiSlice";
import { useGetNotesWithThatLabelQuery } from "./notesLabelsApiSlice";
function EditLabelsList(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const { label } = useGetLabelsQuery("labelsList", {
    selectFromResult: ({ data }) => ({
      label: data?.entities[props.labelId],
    }),
  });
  const [existedLabel, setLabel] = useState(label);
  const [focus, setFocus] = useState(false);
  const [focusIcon, setFocusIcon] = useState(false);
  let helperText;
  function handleOnFocusChange() {
    setFocus(true);
    setFocusIcon(true);
  }
  function handleOnFocusIconChange() {
    setFocusIcon(true);
  }
  function handleOnBlurIconChange() {
    setFocusIcon(false);
  }
  useEffect(() => {
    setLabel(label);
  }, [label]);
  const { refetch } = useGetNotesQuery("notesList");
  const { refetch: refetchNotesLabel } =
    useGetNotesWithThatLabelQuery("notesList");
  const [
    updateLabel,
    {
      isSuccess: isUpdateSuccess,
      isError: isUpdateError,
      error: errorUpdate,
      reset: resetUpdate,
    },
  ] = useUpdateLabelMutation();
  const [
    delLabel,
    {
      isSuccess: isDelSuccess,
      isError: isDelError,
      error: errorDel,
      reset: resetDel,
    },
  ] = useDeleteLabelMutation();
  async function updateLabelClicked() {
    await updateLabel({ id: existedLabel._id, name: existedLabel.name });
  }
  async function delLabelClicked() {
    await delLabel({ id: label._id });
  }
  if (isUpdateError) {
    helperText = <p className="errmsg">{errorUpdate?.data?.message}</p>;
  }
  if (isDelError) {
    helperText = <p className="errmsg">{errorDel?.data?.message}</p>;
  }
  useEffect(() => {
    if (isUpdateSuccess) {
      setFocus(false);
      setFocusIcon(false);
      refetch();
      refetchNotesLabel();
      resetUpdate();
      const options = {
        pathname: `/labels/${existedLabel.name}`,
      };
      if (location.pathname === `/labels/${label.name}`) {
        navigate(options, { state: { id: existedLabel.id }, replace: true });
      }
    }
    if (isDelSuccess) {
      setFocus(false);
      setFocusIcon(false);
      refetch();
      refetchNotesLabel();
      resetDel();
      navigate("/", { replace: true });
    }
  }, [
    isUpdateSuccess,
    resetUpdate,
    isDelSuccess,
    resetDel,
    refetch,
    navigate,
    existedLabel.name,
    existedLabel.id,
    location.pathname,
    label.name,
  ]);
  return (
    <TextField
      //className="edit-labels-list"
      id={existedLabel._id}
      maxwidth="100%"
      size="small"
      sx={{ mt: 2.5 }}
      variant="standard"
      value={existedLabel.name}
      onChange={(e) => {
        setLabel((prevValue) => {
          return {
            ...prevValue,
            name: e.target.value,
          };
        });
      }}
      onFocus={handleOnFocusChange}
      helperText={helperText}
      InputProps={{
        disableUnderline: true,
        startAdornment: (
          <InputAdornment position="start">
            <IconButton
              aria-label="edit"
              onMouseEnter={handleOnFocusIconChange}
              onMouseLeave={handleOnBlurIconChange}
              onClick={() => {
                delLabelClicked();
              }}
            >
              {!focusIcon ? (
                <LabelOutlinedIcon />
              ) : (
                <DeleteOutlineOutlinedIcon />
              )}
            </IconButton>
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              sx={{ ml: 2 }}
              aria-label={!focus ? "edit" : "confirm"}
              size="large"
              onClick={() => {
                !focus ? handleOnFocusChange() : updateLabelClicked();
              }}
            >
              {!focus ? <EditOutlinedIcon /> : <CheckOutlinedIcon />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}

//export default EditLabelsList;
const memoizedEditLabelsList = memo(EditLabelsList);
export default memoizedEditLabelsList;
